export default {
      id: "age-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#age",
      toString: function () {
        return this.url;
      }
    }